import {
  Box,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";

import {
  createPlayoffBucket,
  updatePlayoffBucket,
} from "../../../apis/Playoff";
import { showToast } from "../../../utils/toast";
import FormWrapper from "../../Form/FormWrapper";

export const PlayoffBucketDrawer = ({
  bucket,
  setEditOpen,
  reloadTable,
  setLoading,
}) => {
  // =========================
  // Form
  // =========================

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      is_active: true,
    },
  });

  // =========================
  // Effects
  // =========================

  useEffect(() => {
    reset({
      name: bucket?.name || "",
      is_active: bucket?.is_active ?? true,
    });
  }, [bucket, reset]);

  // =========================
  // Handlers
  // =========================

  const handleSave = async (data) => {
    setLoading(true);

    try {
      if (bucket) {
        await updatePlayoffBucket(bucket.id, data);
      } else {
        await createPlayoffBucket(data);
      }

      await reloadTable();

      setEditOpen(false);

      showToast(
        bucket ? "Bucket updated successfully" : "Bucket added successfully",
        "success",
      );
    } catch (error) {
      console.error(error);

      showToast(
        bucket ? "Failed to update bucket" : "Failed to add bucket",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // Render
  // =========================

  return (
    <FormWrapper onSubmit={handleSubmit(handleSave)} sx={{ p: 5 }}>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h6">
          {bucket ? "Edit PlayOff Bucket" : "Create PlayOff Bucket"}
        </Typography>

        <Button type="submit" variant="contained">
          {bucket ? "Update" : "Save"}
        </Button>
      </Box>

      {/* Bucket Name */}
      <Box mb={3}>
        <TextField
          fullWidth
          label="Bucket Name"
          {...register("name", {
            required: "Bucket name is required",
          })}
          error={Boolean(errors.name)}
          helperText={errors.name?.message}
        />
      </Box>

      {/* Bucket Status */}
      {bucket && (
        <Box mb={3}>
          <Controller
            name="is_active"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                label={field.value ? "Active" : "Inactive"}
                control={
                  <Switch
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    color="primary"
                  />
                }
              />
            )}
          />
        </Box>
      )}
    </FormWrapper>
  );
};
